import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import * as PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

const formatCountdown = (totalSeconds) => {
  const safe = Math.max(0, totalSeconds);
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

const SessionTimeoutWarningModal = ({
  secondsRemaining,
  onStaySignedIn,
  onSignOut,
}) => {
  const [remaining, setRemaining] = useState(secondsRemaining);

  useEffect(() => {
    setRemaining(secondsRemaining);
  }, [secondsRemaining]);

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining((prev) => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Modal
      data-testid="session-timeout-warning-modal"
      className="fade-in"
      show
      backdrop
      centered
    >
      <Modal.Header>
        <b>Your Session Is About To Expire</b>
      </Modal.Header>
      <Modal.Body>
        {`For your security, you will be signed out in ${formatCountdown(
          remaining
        )}. `}
        Any unsaved work will be lost.
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-testid="session-sign-out-button"
          variant={NewButtonVariant.l2}
          onClick={onSignOut}
        >
          Sign Out Now
        </NewButton>
        <NewButton
          data-testid="session-stay-signed-in-button"
          variant={NewButtonVariant.l1}
          onClick={onStaySignedIn}
        >
          Stay Signed In
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionTimeoutWarningModal;

SessionTimeoutWarningModal.propTypes = {
  secondsRemaining: PropTypes.number.isRequired,
  onStaySignedIn: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
};
